module.exports = __webpack_public_path__ + "static/img/sgj.f467e738.png";